import React from 'react';
import TrailCard from './TrailCard';
import Icon from '../../../components/AppIcon';


const TrailsGrid = ({ trails, isLoading = false }) => {
  if (isLoading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
        {[...Array(8)]?.map((_, index) => (
          <div key={index} className="bg-card rounded-lg shadow-card overflow-hidden">
            <div className="aspect-[4/3] bg-muted animate-pulse" />
            <div className="p-6 space-y-3">
              <div className="h-4 bg-muted rounded animate-pulse" />
              <div className="h-3 bg-muted rounded animate-pulse w-3/4" />
              <div className="space-y-2">
                <div className="h-3 bg-muted rounded animate-pulse" />
                <div className="h-3 bg-muted rounded animate-pulse w-5/6" />
              </div>
              <div className="flex gap-2 pt-2">
                <div className="h-8 bg-muted rounded animate-pulse flex-1" />
                <div className="h-8 w-12 bg-muted rounded animate-pulse" />
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  if (!trails || trails?.length === 0) {
    return (
      <div className="text-center py-12">
        <div className="max-w-md mx-auto">
          <div className="w-16 h-16 bg-muted rounded-full flex items-center justify-center mx-auto mb-4">
            <Icon name="Search" size={24} className="text-muted-foreground" />
          </div>
          <h3 className="font-heading font-semibold text-lg text-foreground mb-2">
            No trails found
          </h3>
          <p className="text-muted-foreground text-sm">
            Try adjusting your filters to discover more heritage trails.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
      {trails?.map((trail) => (
        <TrailCard key={trail?.id} trail={trail} />
      ))}
    </div>
  );
};

export default TrailsGrid;